<div mat-dialog-content class="dialog-image-container">
  @if (data.isPdf) {
    <iframe
      [src]="safePdfUrl"
      class="preview-pdf-frame"
      [title]="data.fileName || ('photo.preview.alt' | translate)">
    </iframe>
  } @else {
    <img [src]="data.imageUrl" [alt]="'photo.preview.alt' | translate" class="preview-image" />
  }
</div>
<div mat-dialog-actions class="dialog-actions">
  @if (!isMobile) {
    <span class="dialog-hint">{{ 'photo.preview.hint' | translate }}</span>
  }
  <button mat-raised-button color="primary" (click)="close()">
    <mat-icon>close</mat-icon>
    {{ 'photo.preview.close' | translate }}
  </button>
</div>
